import { useState } from 'react';
import { Chain } from './types';

export default function useChainLogic(chainData: Chain) {
  const [chainState] = useState(chainData);

  return chainState;
}
